import {NgModule} from '@angular/core';
import {CategoryItemListPage} from './category-item-list';
import {RouterModule} from '@angular/router';
import {DirectCategoryItemListPage} from './direct-category-item-list';
import {ItemRouteModule} from '../../routes/item/item.route';
import {SharedModule} from '../../shared/shared.module';
import {ComboModifier} from 'src/app/routes/item/combo-modifier.module';
import {StoreGuard} from '../../core/guards/store.guard';

@NgModule({
    declarations: [CategoryItemListPage, DirectCategoryItemListPage],
    imports: [
        SharedModule,
        ItemRouteModule,
        ComboModifier,
        RouterModule.forChild([
            {
                path: '',
                component: CategoryItemListPage,
                canActivate: [StoreGuard]
            },
            {
                path: 'direct',
                component: DirectCategoryItemListPage,
                canActivate: [StoreGuard]
            }
        ])
    ]
})
export class CategoryItemListModule {
}
